import { useState } from 'react';

const useChangePassword = () => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmedPassword, setConfirmedPassword] = useState('');

    return {
        currentPassword,
        setCurrentPassword,
        newPassword,
        setNewPassword,
        confirmedPassword,
        setConfirmedPassword,
    };
};

export default useChangePassword;
